<template>
  <div class="progress-bar-container">
    <div class="progress-bar">
      <div style="width: 100%; display: flex; height: 10px">
        <div class="inner-footer" :class="firstSegmentRadius" style="background-color: gray;"></div>
        <div class="inner-footer" style="background-color: lightblue;"></div>
        <div class="inner-footer" style="background-color: orange;"></div>
        <div class="inner-footer" :class="lastSegmentRadius" style="background-color: yellow;"></div>
      </div>
      <div :style="mask"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { IS_SURVEY_RTL } from "../../services/constants"

export default {
  name: "ProgressBar",
  props: ['current', 'total'],
  computed: {
    ...mapGetters([
      IS_SURVEY_RTL
    ]),
    firstSegmentRadius () {
      return {
        'left-border-radius': !this[IS_SURVEY_RTL],
        'right-border-radius': this[IS_SURVEY_RTL]
      }
    },
    lastSegmentRadius () {
      return {
        'left-border-radius': this[IS_SURVEY_RTL],
        'right-border-radius': !this[IS_SURVEY_RTL]
      }
    },
    mask () {
      return this[IS_SURVEY_RTL] ? this.rtlMask : this.regularMask
    },
    regularMask () {
      return {
        "background-color": "white",
        "position": "absolute",
        "width": `${((this.total - this.current) / this.total) * 100}%`,
        "top": "0",
        "right": "0",
        "height": "10px",
      }
    },
    rtlMask () {
      return {
        "background-color": "white",
        "position": "absolute",
        "width": `${((this.total - this.current) / this.total) * 100}%`,
        "top": "0",
        "left": "0",
        "height": "10px",
      }
    }
  },
}
</script>

<style scoped lang="scss">
.inner-footer {
  width: 25%;
  height: 10px;
}

.left-border-radius {
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}

.right-border-radius {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}

.progress-bar-container {
  background-color: white;
  border: 1px solid #000;
  border-radius: 13px;
  /* (height of inner div) / 2 + padding */
  padding: 3px;
  height: 10px;
}

.progress-bar {
  position: relative;
  width: 100%;
  height: 10px;
  border-radius: 10px;
}
</style>
